<template>
    <div class="modal fade" id="cannotHide" tabindex="-1" role="dialog" aria-labelledby="confirmSingleHideProduct" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{headerMsg}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{hideMessage ? hideMessage : 'Cannot hide as part of campaign'}}</p>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'CannotHidePopUp',
    data() {
        return {

        }
    },
    props: {
		hideMessage : {
			type: String,
			default: 'Cannot Hide as already added to a campaign'
		},
		headerMsg : {
			type: String,
			default: 'Hide'
		}
    },
	mounted(){
		//
		if(this.hideMessage == ""){
			this.$emit("ProvideVal")
		}
	},
    methods: {

    },
}
</script>

<style lang="scss">

</style>
